import {
  ResponsiveContainer,
  Cell,
  Pie,
  PieChart,
  Tooltip,
  Legend,
} from "recharts";
import ManIcon from "@mui/icons-material/Man";
import WomanIcon from "@mui/icons-material/Woman";

const convertToPieData = (data) => {
  return data.map((item) => ({
    name: item.teachingLevel,
    value: item.total,
  }));
};

const calculateSummary = (data) => {
  return data.map((item) => ({
    teachingLevel: item.teachingLevel,
    male: item.male,
    female: item.female,
    total: item.total,
    teachingAndAdministrativeStaffTotal:
      item.teachingAndAdministrativeStaffTotal,
    teachingStaffTotal: item.teachingStaffTotal,
  }));
};

export default function TeachingLevelDistributionChart({ data }) {
  const pieData = convertToPieData(data);
  const summary = calculateSummary(data);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "30px" }}>
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={pieData}
            cx="50%"
            cy="50%"
            labelLine={false}
            outerRadius={100}
            fill="#8884d8"
            dataKey="value"
            nameKey="name"
            label={({ name, value, percent }) =>
              `${name}: ${(percent * 100).toFixed(0)}%`
            }
          >
            {pieData.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={`hsl(var(--chart-${index + 1}))`}
              />
            ))}
          </Pie>
          <Tooltip
            formatter={(value, label) => [
              `${value?.toLocaleString()} ${
                value == 1 ? "Teacher" : "Teachers"
              }`,
              label,
            ]}
          />
          <Legend />
        </PieChart>
      </ResponsiveContainer>

      <div
        style={{
          fontSize: "14px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          gap: "20px",
          width: "100%",
        }}
      >
        <div style={{ textAlign: "center", width: "100%" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <WomanIcon style={{ fontSize: 40, color: "hsl(var(--chart-2))" }} />
            <div>
              <span>Female</span>
            </div>
          </div>
          <table
            style={{
              width: "100%",
              marginTop: "10px",
              borderCollapse: "collapse",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    borderBottom: "1px solid #ccc",
                    padding: "5px",
                    background: "rgb(237, 108, 2)",
                    color: "white",
                  }}
                >
                  Pre-Primary
                </th>
                <th
                  style={{
                    borderBottom: "1px solid #ccc",
                    padding: "5px",
                    background: "rgb(237, 108, 2)",
                    color: "white",
                  }}
                >
                  Primary
                </th>
                <th
                  style={{
                    borderBottom: "1px solid #ccc",
                    padding: "5px",
                    background: "rgb(237, 108, 2)",
                    color: "white",
                  }}
                >
                  Secondary
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  style={{
                    padding: "5px",
                    background: "rgb(236, 202, 174)",
                    fontWeight: "bold",
                  }}
                >
                  {summary
                    .find((item) => item.teachingLevel === "PRE_PRIMARY")
                    ?.female?.toLocaleString()}
                </td>
                <td
                  style={{
                    padding: "5px",
                    background: "rgb(236, 202, 174)",
                    fontWeight: "bold",
                  }}
                >
                  {summary
                    .find((item) => item.teachingLevel === "PRIMARY")
                    ?.female?.toLocaleString()}
                </td>
                <td
                  style={{
                    padding: "5px",
                    background: "rgb(236, 202, 174)",
                    fontWeight: "bold",
                  }}
                >
                  {summary
                    .find((item) => item.teachingLevel === "SECONDARY")
                    ?.female?.toLocaleString()}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div style={{ textAlign: "center", width: "100%" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ManIcon style={{ fontSize: 40, color: "hsl(var(--chart-1))" }} />
            <div>
              <span>Male</span>
            </div>
          </div>
          <table
            style={{
              width: "100%",
              marginTop: "10px",
              borderCollapse: "collapse",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    borderBottom: "1px solid #ccc",
                    padding: "5px",
                    background: "rgb(1, 81, 152)",
                    color: "white",
                  }}
                >
                  Pre-Primary
                </th>
                <th
                  style={{
                    borderBottom: "1px solid #ccc",
                    padding: "5px",
                    background: "rgb(1, 81, 152)",
                    color: "white",
                  }}
                >
                  Primary
                </th>
                <th
                  style={{
                    borderBottom: "1px solid #ccc",
                    padding: "5px",
                    background: "rgb(1, 81, 152)",
                    color: "white",
                  }}
                >
                  Secondary
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  style={{
                    padding: "5px",
                    background: "rgb(197, 221, 241)",
                    fontWeight: "bold",
                  }}
                >
                  {summary
                    .find((item) => item.teachingLevel === "PRE_PRIMARY")
                    ?.male?.toLocaleString()}
                </td>
                <td
                  style={{
                    padding: "5px",
                    background: "rgb(197, 221, 241)",
                    fontWeight: "bold",
                  }}
                >
                  {summary
                    .find((item) => item.teachingLevel === "PRIMARY")
                    ?.male?.toLocaleString()}
                </td>
                <td
                  style={{
                    padding: "5px",
                    background: "rgb(197, 221, 241)",
                    fontWeight: "bold",
                  }}
                >
                  {summary
                    .find((item) => item.teachingLevel === "SECONDARY")
                    ?.male?.toLocaleString()}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div style={{ width: "100%", marginTop: "-10px" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontSize: "14px",
          }}
        >
          <thead>
            <tr>
              <th
                style={{
                  padding: "8px",
                  background: "white",
                  borderBottom: "1px solid #ddd",
                  textAlign: "left",
                  width: "25%",
                }}
              ></th>
              <th
                style={{
                  padding: "8px",
                  background: "rgb(1, 81, 152)",
                  textAlign: "center",
                  color: "white",
                  borderBottom: "1px solid #ddd",
                }}
              >
                Pre-Primary
              </th>
              <th
                style={{
                  padding: "8px",
                  background: "rgb(237, 108, 2)",
                  textAlign: "center",
                  color: "white",
                  borderBottom: "1px solid #ddd",
                }}
              >
                Primary
              </th>
              <th
                style={{
                  padding: "8px",
                  background: "hsl(var(--chart-3))",
                  textAlign: "center",
                  color: "white",
                  borderBottom: "1px solid #ddd",
                }}
              >
                Secondary
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                style={{
                  padding: "8px",
                  borderBottom: "1px solid #ddd",
                  borderLeft: "1px solid #ddd",
                  fontWeight: "bold",
                  background: "#f9f9f9",
                }}
              >
                All Staff
              </td>
              <td
                style={{
                  padding: "8px",
                  borderBottom: "1px solid #ddd",
                  textAlign: "center",
                  background: "rgba(1, 81, 152, 0.1)",
                }}
              >
                {(() => {
                  const item = summary.find(
                    (item) => item.teachingLevel === "PRE_PRIMARY"
                  );
                  return item
                    ? item.teachingAndAdministrativeStaffTotal.toLocaleString()
                    : "0";
                })()}
              </td>
              <td
                style={{
                  padding: "8px",
                  borderBottom: "1px solid #ddd",
                  textAlign: "center",
                  background: "rgba(237, 108, 2, 0.1)",
                }}
              >
                {(() => {
                  const item = summary.find(
                    (item) => item.teachingLevel === "PRIMARY"
                  );
                  return item
                    ? item.teachingAndAdministrativeStaffTotal.toLocaleString()
                    : "0";
                })()}
              </td>
              <td
                style={{
                  padding: "8px",
                  borderBottom: "1px solid #ddd",
                  textAlign: "center",
                  background: "rgba(1, 8, 2, 0.1)",
                }}
              >
                {(() => {
                  const item = summary.find(
                    (item) => item.teachingLevel === "SECONDARY"
                  );
                  return item
                    ? item.teachingAndAdministrativeStaffTotal.toLocaleString()
                    : "0";
                })()}
              </td>
            </tr>
            <tr>
              <td
                style={{
                  padding: "8px",
                  borderBottom: "1px solid #ddd",
                  borderLeft: "1px solid #ddd",
                  fontWeight: "bold",
                  background: "#f9f9f9",
                }}
              >
                Teaching Staff
              </td>
              <td
                style={{
                  padding: "8px",
                  borderBottom: "1px solid #ddd",
                  textAlign: "center",
                  background: "rgba(1, 81, 152, 0.1)",
                }}
              >
                {summary
                  .find((item) => item.teachingLevel === "PRE_PRIMARY")
                  ?.teachingStaffTotal?.toLocaleString() || "0"}
              </td>
              <td
                style={{
                  padding: "8px",
                  borderBottom: "1px solid #ddd",
                  textAlign: "center",
                  background: "rgba(237, 108, 2, 0.1)",
                }}
              >
                {summary
                  .find((item) => item.teachingLevel === "PRIMARY")
                  ?.teachingStaffTotal?.toLocaleString() || "0"}
              </td>
              <td
                style={{
                  padding: "8px",
                  borderBottom: "1px solid #ddd",
                  textAlign: "center",
                  background: "rgba(1, 8, 2, 0.1)",
                }}
              >
                {summary
                  .find((item) => item.teachingLevel === "SECONDARY")
                  ?.teachingStaffTotal?.toLocaleString() || "0"}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
